import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { UserRepository } from '../../repositories/user.repository';
import { UserTourModel } from '../../models/user/user-tour.model';

export class GetStateTourUseCase implements UseCase<void, UserTourModel> {
    constructor(private userRepository: UserRepository) { }
execute(): Observable<UserTourModel> {
        return this.userRepository.getStateTour();
    }
}
